<header>
    <mat-toolbar>
        <mat-toolbar-row>
            <div class="flex justify-between w-full">
                <button
                    class="sidenav-button-highlight"
                    mat-icon-button
                    aria-label="Menu icon"
                    (click)="toggleSidenav()"
                >
                    <mat-icon class="text-white">menu</mat-icon>
                </button>

                <img
                    alt="Cevo Go logo"
                    class="w-20"
                    src="assets/svg/cevo-go.svg"
                />

                <div class="w-[48px]"></div>
            </div>
        </mat-toolbar-row>
    </mat-toolbar>
</header>

<mat-sidenav-container (backdropClick)="toggleSidenav()">
    <mat-sidenav
        [disableClose]="true"
        mode="over"
        [opened]="true"
        class="!shadow-2xl"
        [class]="[
            !isCollapsed ? '!w-[268px]' : '',
            user?.isMasqueraded ? '!bg-error-50' : '',
        ]"
    >
        @if (!isCollapsed) {
            <mat-nav-list>
                @for (item of navigationIconLinks; track item) {
                    <app-sidenav-item
                        [item]="item"
                        [isMember]="true"
                        [isCollapsed]="isCollapsed"
                        [isCustomer]="true"
                        (click)="toggleSidenav()"
                    ></app-sidenav-item>
                }
                <app-go-sidenav-bottom-panel></app-go-sidenav-bottom-panel>
            </mat-nav-list>
        }
    </mat-sidenav>
    <mat-sidenav-content class="px-5 py-7 bg-neutral-200 mt-3">
        <ng-content></ng-content>
    </mat-sidenav-content>
</mat-sidenav-container>
